<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row>
            <mu-col width="100" tablet="50" desktop="50" v-if="$store.state.user.settings.hba1c.measure === 'percentage'">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:25'"
                data-vv-name="hba1c_percent"
                data-vv-as="%"
                data-vv-value-path="inputValue"
                :errorText="errors.first('hba1c_percent')"
                :label="$t('message.cardHbA1c')"
                v-model.number="reading.percent"
                :hintText="$t('message.placeholderText')"
                :fullWidth="true"
                helpText="%"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50" v-if="$store.state.user.settings.hba1c.measure === 'mmol-mol'">
              <mu-text-field
                v-validate
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:300'"
                data-vv-name="hba1c_mmol_mol"
                data-vv-as="mmol/mmol"
                data-vv-value-path="inputValue"
                :errorText="errors.first('hba1c_mmol_mol')"
                :label="$t('message.cardHbA1c')"
                v-model.number="reading.mmol_mol"
                :hintText="$t('message.placeholderText')"
                :fullWidth="true"
                helpText="mmol/mol"
              />
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>

    <button type="submit" style="display:none"></button>

    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>


  import HbA1cApi from '../../../../api/Tracking/HbA1c'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'


  export default {
    mixins: [TrackingEditMixin],
    name: 'hba1c-edit',
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isUpdating: false,
        reading: {}
      }
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isUpdating = true;
            HbA1cApi.putHba1cTracking(self.reading)
              .then(function (response) {
                self.isUpdating = false;
                let offset = new Date();
                self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
                self.$EventBus.$emit('updateGraphData');
                self.$emit('updateReading', self.reading);
                self.$emit('closeEditPanel')
              })
              .catch(function () {
                self.isUpdating = false;
              })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HbA1cEdit.vue?2d3b6343